module.exports = __webpack_public_path__ + "static/media/0.27482e22.jpeg";